import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'db-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() label: string;
  @Input() id: any;
  @Input() formGroup: FormGroup;
  @Input() controlName: any;
  @Input() inline: boolean;

  constructor() { }

  ngOnInit() {
  }

}
